import React from "react";
import DataTableBase from "./dataTableBase";
import { userColumns } from "./columnDefs";

export default function UsersTable({ users = [] }) {
  return (
    <DataTableBase
      title={"Users"}
      data={users}
      columns={userColumns}
      orderby="time_created"
    />
  );
}
